import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import '../App.css';

function Services() {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animate');
        }
      });
    };

    setTimeout(() => {
      handleScroll();
    }, 100);
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const services = [
    {
      title: 'शराब की लत',
      description: 'निहांश फाउंडेशन से पटना, बिहार में सर्वश्रेष्ठ शराब की लत का उपचार प्राप्त करें। हमारे अनुभवी डॉक्टर और परामर्शदाता आपको नशामुक्त जीवन जीने में मदद करते हैं।',
      image: '/images/Alcohol addiction 01.jpg'
    },
    {
      title: 'सिगरेट की लत',
      description: 'निहांश फाउंडेशन से पटना, बिहार में सर्वोत्तम सिगरेट व्यसन उपचार प्राप्त करें। हमारे कार्यक्रम आपको धूम्रपान छोड़ने में प्रभावी रूप से मदद करते हैं।',
      image: '/images/Cigarette addiction 1.jpg'
    },
    {
      title: 'ब्राउन शुगर',
      description: 'निहांश फाउंडेशन से पटना, बिहार में सर्वोत्तम ब्राउन शुगर व्यसन उपचार प्राप्त करें। हमारे व्यापक उपचार कार्यक्रम आपकी पुनर्प्राप्ति में मदद करते हैं।',
      image: '/images/Brown sugar.jpg'
    },
    {
      title: 'इंजेक्शन की लत',
      description: 'निहांश फाउंडेशन से पटना, बिहार में सर्वश्रेष्ठ इंजेक्शन की लत का उपचार प्राप्त करें। हमारे चिकित्सकीय दृष्टिकोण से सुरक्षित और प्रभावी उपचार मिलता है।',
      image: '/images/Injection addiction.jpg'
    },
    {
      title: 'सुखा नशा',
      description: 'निहांश फाउंडेशन से पटना, बिहार में सर्वोत्तम सुखा नशा उपचार प्राप्त करें। हमारे विशेषज्ञ आपको इस कठिन यात्रा में मार्गदर्शन प्रदान करते हैं।',
      image: '/images/Sukha nasha.jpg'
    },
    {
      title: 'सुलेशन',
      description: 'निहांश फाउंडेशन से पटना, बिहार में सर्वोत्तम सुलेशन व्यसन उपचार प्राप्त करें। हमारे व्यक्तिगत उपचार कार्यक्रम आपकी विशिष्ट आवश्यकताओं के अनुरूप हैं।',
      image: '/images/Sulesion.jpg'
    }
  ];

  return (
    <div className="App">
      <SEO
        title="Services - Best Nasha Mukti in Patna & Bihar | Nihansh Foundation"
        description="Nasha Mukti services in Patna - Alcohol, Drug, Cigarette addiction treatment. Best Nasha Mukti in Patna & Bihar."
        path="/services"
      />
      {/* Services Hero */}
      <section className="page-hero">
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">हमारी सेवाएं</h1>
          <p className="page-hero-subtitle">विभिन्न प्रकार की नशे की लत के लिए व्यापक उपचार</p>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <div className="services-wrapper">
            <div className="services-grid">
              {services.map((service, index) => (
                <div 
                  key={index} 
                  className="service-card animate-on-scroll" 
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <div className="service-number">{index + 1}</div>
                  <div className="service-image-wrapper">
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="service-image" 
                    />
                    <div className="service-overlay"></div>
                    <div className="service-icon-badge">
                      <span className="service-icon">💊</span>
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                    <div className="service-footer">
                      <span className="service-arrow">→</span>
                      <span className="service-link-text">विस्तृत जानकारी</span>
                    </div>
                  </div>
                  <div className="service-gradient-border"></div>
                </div>
              ))}}
            </div>
            <div className="services-background-elements">
              <div className="floating-shape shape-1"></div>
              <div className="floating-shape shape-2"></div>
              <div className="floating-shape shape-3"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Therapy & Yoga Section */}
      <section className="therapy-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll">हमारे उपचार कार्यक्रम</h2>
          <div className="therapy-grid">
            <div className="therapy-card animate-on-scroll">
              <div className="therapy-image-wrapper">
                <img 
                  src="/events/counselling.jpeg" 
                  alt="Therapy Session" 
                  className="therapy-image" 
                />
                <div className="therapy-overlay"></div>
              </div>
              <div className="therapy-content">
                <h3 className="therapy-title">परामर्श सत्र</h3>
                <p className="therapy-description">
                  हमारे अनुभवी परामर्शदाता आपको व्यक्तिगत और समूह परामर्श सत्र प्रदान करते हैं जो पुनर्प्राप्ति में मदद करते हैं।
                </p>
              </div>
            </div>
            <div className="therapy-card animate-on-scroll">
              <div className="therapy-image-wrapper">
                <img 
                  src="/images/yoga session.jpg" 
                  alt="Yoga Session" 
                  className="therapy-image" 
                />
                <div className="therapy-overlay"></div>
              </div>
              <div className="therapy-content">
                <h3 className="therapy-title">योग सत्र</h3>
                <p className="therapy-description">
                  योग और ध्यान के माध्यम से मन और शरीर को शांत करें। हमारे नियमित योग सत्र आपकी पुनर्प्राप्ति यात्रा का एक महत्वपूर्ण हिस्सा हैं।
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;

